import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-ingreso-info',
  templateUrl: './ingreso-info.component.html',
  styleUrls: ['./ingreso-info.component.css']
})
export class IngresoInfoComponent implements OnInit {
  @Input() data: any;

  constructor(
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    console.log(this.data);
  }

  aceptar() {
    this.activeModal.close({ estado: true })
  }

}
